// store.ts
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './reducer/auth';
import { combineReducers } from 'redux';
import generalSlice from './reducer/general';

// 1. Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  general: generalSlice,
});

// 2. Persist config
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'], // зөвхөн auth slice хадгалах
};

// 3. Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 4. Store үүсгэх
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // persist-тэй ажиллахад шаардлагатай
    }),
});

// 5. Persistor үүсгэх
export const persistor = persistStore(store);

// 6. Type тодорхойлох
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
